import { useMemo, useState } from "react";
import { Button } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import CategoryCard from "./CategoryCard";

const CategoryGrid = ({ categories }) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  const sortedCategories = useMemo(() => {
    if (!Array.isArray(categories)) {
      return [];
    }

    return [...categories].sort(
      (firstCategory, secondCategory) =>
        Number(secondCategory?.courseCount || 0) -
        Number(firstCategory?.courseCount || 0),
    );
  }, [categories]);

  const visibleCategories = showAll
    ? sortedCategories
    : sortedCategories.slice(0, 8);

  if (sortedCategories.length === 0) {
    return (
      <h1 className="flex items-center justify-center text-center">
        {t("noCategories", "No categories exist!")}
      </h1>
    );
  }

  return (
    <section className="px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8 lg:-mt-20">
      <h2 className="mb-6 text-2xl font-semibold text-center">
        {t("faculty")}
      </h2>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {visibleCategories.map((category) => (
          <CategoryCard key={category._id} category={category} />
        ))}
      </div>

      {sortedCategories.length > 8 && (
        <div className="flex justify-center mt-8">
          <Button
            type="button"
            variant="gradient"
            color="white"
            style={{
              backgroundColor: "#334780",
              color: "#fff",
            }}
            size="sm"
            onClick={() => setShowAll((currentValue) => !currentValue)}
          >
            {showAll
              ? t("show-less-faculties", "Show Less Faculties")
              : t("load-more-faculties", "Load More Faculties")}
          </Button>
        </div>
      )}
    </section>
  );
};

export default CategoryGrid;
